import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <img 
              src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/e73311cce7ef728ccc6bdfd961a34f39.png" 
              alt="Green Leads Network Logo" 
              className="h-8 sm:h-12 w-auto"
            />
            <span className="text-base sm:text-xl font-bold text-emerald-600">
              Green Leads Network
            </span>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600">Features</a>
            <a href="#about" className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600">About</a>
            <a href="#testimonials" className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600">Success Stories</a>
            <a href="#services" className="text-sm font-medium text-gray-700 transition-colors hover:text-emerald-600">Services</a>
            <a href="#contact" className="bg-emerald-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
              Get Started
            </a>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-emerald-600 cursor-pointer"
            aria-label="Toggle menu"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 animate-slideUp">
            <div className="flex flex-col gap-4">
              <a 
                href="#features" 
                onClick={handleNavClick}
                className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors py-2 cursor-pointer"
              >
                Features
              </a>
              <a 
                href="#about" 
                onClick={handleNavClick}
                className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors py-2 cursor-pointer"
              >
                About
              </a>
              <a 
                href="#testimonials" 
                onClick={handleNavClick}
                className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors py-2 cursor-pointer"
              >
                Success Stories
              </a>
              <a 
                href="#services" 
                onClick={handleNavClick}
                className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors py-2 cursor-pointer"
              >
                Services
              </a>
              <a 
                href="#contact" 
                onClick={handleNavClick}
                className="bg-emerald-600 text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-emerald-700 transition-colors text-center cursor-pointer"
              >
                Get Started
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
